import { render, staticRenderFns } from "./ChatUnread.vue?vue&type=template&id=66074bae"
import script from "./ChatUnread.vue?vue&type=script&lang=js"
export * from "./ChatUnread.vue?vue&type=script&lang=js"
import style0 from "./ChatUnread.vue?vue&type=style&index=0&id=66074bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports